export default __webpack_public_path__ + "static/media/2020-3.6e77b973.png";